<nav class="navbar navbar-expand-lg navbar-light  fixed-top auth-header">
    <div class="container">
        <button class="border-0 bg-transparent d-md-none" routerLink="/signin" *ngIf="common.showBackButton">
            <i class="fas fa-arrow-left"></i>
        </button>
        <a [ngClass]="{'d-none': !common.isNative}" class="navbar-brand mr-0" routerLink="/"><img class="header-logo" src="assets/images/logo.svg"></a>
        <a [ngClass]="{'d-none': common.isNative}" class="navbar-brand mr-0" routerLink="/"><img class="header-logo" src="assets/images/logo.svg"></a>
        <div>
            <button [ngClass]="{'d-none': common.isNative}" class="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <i  class="toggle-icon fas fa-bars fa-lg"></i>
            </button>
        </div>
        
        <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
            <div class="w-100 mt-3 text-right sm-22 d-block d-md-none">
                
                <a type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" class=" navbar-toggler border-0 check_check">
                    
                    <i style="color:#266DD3!important; font-size: 30px!important; background:transparent !important;" class="toggle-icon fas fa-times" ></i>
                </a>
                
            </div>
            <ul class="navbar-nav auth-nav pt-5 pt-md-0">
                <li class="nav-item text-left text-md-center dropdown NavbarsendMoney-dropdown">
                    <!-- <a class="nav-link" [routerLink]="['/send-money']" routerLinkActive="router-link-active"  id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Send money
                    </a> -->
                    <a class="nav-link dropdown-toggle cursor-pointer "  routerLinkActive="router-link-active" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Send money
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" routerLink="/cad-to-inr">CAD to INR</a>
                        <a class="dropdown-item" routerLink="/cad-to-ngn">CAD to NGN</a>
                        <a class="dropdown-item" routerLink="/cad-to-kes">CAD to KES</a>
                        <a class="dropdown-item" routerLink="/cad-to-ghs">CAD to GHS</a>
                        <a class="dropdown-item" routerLink="/cad-to-xof">CAD to XOF</a>
                        <a class="dropdown-item" routerLink="/cad-to-php">CAD to PHP</a>
                        <a class="dropdown-item" routerLink="/cad-to-zar">CAD to ZAR</a>
                        <!-- <a class="dropdown-item" routerLink="/cad-to-gbp">CAD to GBP</a> -->
                        <!-- <a class="dropdown-item" routerLink="/cad-to-eur">CAD to EUR</a> -->
                        <!-- <a class="dropdown-item" routerLink="/usd-to-inr">USD to INR</a>
                        <a class="dropdown-item" routerLink="/usd-to-ghs">USD to GHS</a> -->
                        <!-- <a class="dropdown-item" routerLink="/usd-to-ngn">USD to NGN</a> -->
                        <!-- <a class="dropdown-item" routerLink="/usd-to-kes">USD to KES</a> -->
                    </div>
                </li>
                <!-- <li class="nav-item text-left text-md-center">
                    <a class="nav-link" [routerLink]="['/pay-bills']" >Pay bills</a>
                </li> -->
                <li class="nav-item text-left text-md-center active">
                    <a class="nav-link" [routerLink]="['/about']">About <span class="sr-only">(current)</span></a>
                </li>
                <li class="nav-item text-left text-md-center">
                    <a class="nav-link" href="https://blog.n2xpress.com/">Blog</a>
                </li>
                
                <li class="nav-item text-left text-md-center">
                    <a class="nav-link" routerLink="/frequently-asked-questions">FAQ</a>
                </li>
                <li class="nav-item text-left pl-3 pl-md-0 text-md-center" *ngIf="!auth.user">
                    <button [routerLink]="['/signin']"   class="btn primary-btn nav-register rasputin">Sign in</button>
                </li>
                <li class="nav-item text-left pl-3 pl-md-0 text-md-center" *ngIf="!auth.user">
                    <button [routerLink]="['/register']" class="btn primary-btn nav-login rasputin ">Sign up</button>
                </li>
                <li *ngIf="auth.user" class="nav-item text-left text-md-center dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{auth.user.name}}
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" routerLink="/dashboard">Dashboard</a>
                        <a class="dropdown-item cursor-pointer" (click)="auth.logout()">Logout</a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</nav>